import { usePersistableState } from "@/shared/hooks";
import type { DEFAULT_NOTE_DIRECTIONS } from "@/services/api";
import type { Key } from "react";

export const useNotesTablePersistFilters = ({
  widgetId,
  menuFilterName,
}: {
  widgetId?: string;
  menuFilterName?: string;
}) => {
  const [fromDate, setFromDate, clearFromDate] = usePersistableState<string>({
    initialValue: "",
    stateName: `fromDate-${widgetId}`,
    persistable: !!widgetId,
  });

  const [toDate, setToDate, clearToDate] = usePersistableState<string>({
    initialValue: "",
    stateName: `toDate-${widgetId}`,
    persistable: !!widgetId,
  });

  const [fromDueDate, setFromDueDate, clearFromDueDate] = usePersistableState<string>({
    initialValue: "",
    stateName: `fromDueDate-${widgetId}`,
    persistable: !!widgetId,
  });

  const [toDueDate, setToDueDate, clearToDueDate] = usePersistableState<string>({
    initialValue: "",
    stateName: `toDueDate-${widgetId}`,
    persistable: !!widgetId,
  });

  const [menuFilter, setMenuFilter, clearMenuFilter] = usePersistableState<Key[]>({
    stateName: `${menuFilterName}-${widgetId}`,
    persistable: !!menuFilterName && !!widgetId,
    initialValue: [],
  });

  const [directionFilter, setDirectionFilter, clearDirectionFilter] = usePersistableState<
    keyof typeof DEFAULT_NOTE_DIRECTIONS
  >({
    persistable: !!widgetId,
    initialValue: "ALL",
    stateName: `directionFilter-${widgetId}`,
  });

  const clearAllFilters = () => {
    clearToDate();
    clearFromDate();
    clearToDueDate();
    clearFromDueDate();
    clearMenuFilter();
    clearDirectionFilter();
    if (!widgetId) return;
    Object.keys(localStorage).forEach((key) => {
      if (key.includes(widgetId)) {
        localStorage.removeItem(key);
      }
    });
  };

  return {
    date: { fromDate, toDate, setFromDate, setToDate },
    dueDate: { fromDueDate, toDueDate, setFromDueDate, setToDueDate },
    menuFilter: {
      menuFilter,
      setMenuFilter,
    },
    directionFilter: {
      directionFilter,
      setDirectionFilter,
    },
    clearAllFilters,
  };
};
